import {
    getData,
    postData,
    patchData,
    deleteData
} from './Services'

export const getSubrubrosPanel = async (searchTerm,searchFilter ,secondSearchFilter,page, perPage) => {
    let queryParams = [];
    if (searchTerm) {
        queryParams.push(`descripcion_subrubro=${encodeURIComponent(searchTerm || '')}`);
    }
    if (searchFilter) {
        queryParams.push(`rubro_id=${encodeURIComponent(searchFilter || '')}`);
    }
    if (secondSearchFilter) {
        queryParams.push(`ramo_id=${encodeURIComponent(secondSearchFilter|| '')}`);
    }
    if (page) {
        queryParams.push(`page=${encodeURIComponent(page || 1)}`);
    }
    if (perPage) {
        queryParams.push(`perPage=${encodeURIComponent(perPage || 10)}`);
    }
    const queryString = queryParams.length > 0 ? `?&${queryParams.join('&')}` : '';
    return await getData("/subrubros", queryString);
};

export const getSubrubroById = async (id) => {
    const res = await getData(`/subrubros/${id}`)
    return res
}

export const getXSubrubro = async (searchTerm) => {
    return await getData("/subrubros", `?descripcion_subrubro=${searchTerm}`);
};

export const postSubrubro = async (body) => {
    const res = await postData('/subrubros', body)
    return res
}

export const patchSubrubro = async (id, body) => {
    const res = await patchData(`/subrubros/${id}`, body)
    return res
}

export const deleteSubrubro = async (id) => {
    const res = await deleteData(`/subrubros/${id}`)
    return res
}

export const getSubrubrosxRubro = async (id) => {
    const res = await getData(`/subrubros/rubro_subrubros/${id}`)
    return res
}

export const getAllRubros = async () => {
    const res = await getData(`/rubros/rubros_select`)
    return res
}

export const getAllRamos = async () => {
    const res = await getData(`/ramos/ramos_select`)
    return res
}